'use strict';

var throttle = require('lodash/throttle');

class ProductCtaBox {
    constructor(component, header, attributes) {
        this.component = component;
        this.container = this.component.closest('.container');
        this.productDetailInfo = this.component.querySelector('.product-detail-info');
        this.disableStickyClass = 'not-sticky';

        this.header = header;
        this.attributes = attributes;
    }

    readyCallback() {
        if (!this.component) {
            return;
        }

        this.tooTall = this.checkTooTall();

        if (this.tooTall) {
            this.mapStickyEvents();
            this.stickyBehavior();
        } else {
            this.component.classList.remove(this.disableStickyClass);
        }

        if (!this.productDetailInfo) {
            return;
        }

        this.mapThumbnailEvents();
        this.thumbnailBehavior();
    }

    mapStickyEvents() {
        const callback = throttle(() => {
            this.stickyBehavior();
        }, 500);

        window.addEventListener('resize', callback);
        window.addEventListener('orientationchange', callback);
        window.addEventListener('scroll', callback);
    }

    mapThumbnailEvents() {
        const callback = throttle(() => {
            this.thumbnailBehavior();
        }, 500);

        window.addEventListener('resize', callback);
        window.addEventListener('orientationchange', callback);
        window.addEventListener('scroll', callback);
    }

    checkTooTall() {
        const containerTop = this.container.getBoundingClientRect().top + window.scrollY;
        const boxHeight = this.component.offsetHeight;
        const viewportHeight = window.innerHeight;

        return (containerTop + boxHeight > viewportHeight);
    }

    stickyBehavior() {
        const containerTop = this.container.getBoundingClientRect().top;
        const boxTop = this.component.getBoundingClientRect().top;
        const boxBottom = this.component.getBoundingClientRect().bottom + this.component.offsetHeight - window.innerHeight;

        let sticky = true;
        let invisible = false;
        if (!this.component.classList.contains(this.disableStickyClass) && containerTop === boxTop) {
            // stick to top
            sticky = false;
        }

        if (this.component.classList.contains(this.disableStickyClass)) {
            if (boxBottom < -5) {
                // we're out of sight
                invisible = true;
            }

            if (boxBottom > -30) {
                // keep stuck to top
                sticky = false;
            }
        }

        this.component.classList.toggle(this.disableStickyClass, !sticky);
        this.component.classList.toggle('condensed', sticky);
        this.component.classList.toggle('invisible', invisible);
    }

    thumbnailBehavior() {
        if (!this.attributes) {
            return;
        }

        let viewTop = 0;

        if (this.header) {
            viewTop += this.header.offsetHeight;
        }

        const attributesTop = this.attributes.getBoundingClientRect().top;
        this.productDetailInfo.classList.toggle('show-thumbnail', attributesTop < viewTop);
    }
}

module.exports = function () {
    const boxElement = document.querySelector('.product-detail-col-cta');
    const headerElement = document.querySelector('.js-header');
    const attributesElement = document.querySelector('.product-detail-attributes');

    if (boxElement) {
        const box = new ProductCtaBox(
            boxElement,
            headerElement,
            attributesElement
        );
        box.readyCallback();
    }
};
